import { useMemo, useState } from "react";
import { arModelMagic } from "@greg-chick/shared";
import { PageMagicPreview } from "./PageMagicPreview";

/**
 * 🧊 **올린 3D 를 그 자리에서 돌려 본다** — 3D 칸 안의 작은 미리보기(2026-09-14).
 *
 * 운영자는 .glb 를 올리고 「제대로 올라갔나·방향이 맞나·너무 크지 않나」를 게시 전에 봐야 한다.
 *
 * ## 🔴 새로 짜지 않는다
 * 아이 화면이 AR 보기 ④ 3D 에 쓰는 「3D 층 하나짜리 마법」(shared `arModelMagic`)을 마법 미리보기
 * (`PageMagicPreview` → 아이 화면의 `BookModelStage`)에 그대로 넣는다 — 무대·손짓·표시·출처가 아이 화면과 같다.
 *
 * 누르기 전에는 안 연다 — 엔진(A-Frame)은 수백 KB 라 칸을 훑기만 하는 운영자에게 싣지 않는다.
 */
export function Model3dMini({ url, credit, label }: { url: string | undefined; credit?: string; label: string }) {
  const m = useMemo(() => arModelMagic(false, url, credit), [url, credit]);
  const [open, setOpen] = useState(false);
  if (!m) return null;
  if (!open) {
    return (
      <button type="button" className="btn btn--sm" onClick={() => setOpen(true)} aria-label={`${label} 3D 돌려 보기`}>
        🧊 돌려 보기
      </button>
    );
  }
  return (
    <div className="model3d-mini" data-model3d-mini>
      <div className="model3d-mini__stage">
        {/* url 이 바뀌면 새 무대로 — 옛 3D 의 각도·배율을 새 파일에 들고 가지 않게 */}
        <PageMagicPreview key={url} def={m.magic} layers={{}} models={m.models} />
      </div>
      <button type="button" className="btn btn--sm" onClick={() => setOpen(false)}>
        접기
      </button>
    </div>
  );
}
